export const encodeSpacesInUrl = (url: string) => {
  // This function should take into consideration the empty spaces on names
  // and encode them with %20
  // Example: "Bitcoin Cash" => "Bitcoin%20Cash"

  return url.replace(" ", "%20");

};